import "core-js/stable";
import "regenerator-runtime/runtime";
import { Component, createState, Stateful } from "dreamland/core";
import { Route, router, Router } from "dreamland/router";

import "./style.css";
import Nav from "./components/Nav";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Bookmarks from "./pages/Bookmarks";
import Notifications from "./pages/Notifications";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Timeline from "./pages/Timeline";

let page: Stateful<{
	url?: string;
}> = createState({});

const App: Component<{}, {}> = function (cx) {
	const routerInstance = (
		<Router
			children={[
				<Route path="" show={() => <Landing />} />,
				<Route path="login" show={() => <Login />} />,
				<Route path="auth">
					<Route path="callback" show={() => <AuthCallback />} />
				</Route>,
				<Route path="bookmarks" show={() => <><Bookmarks /><Nav active="bookmarks" /></>} />,
				<Route path="notifications" show={() => <><Notifications /><Nav active="notifications" /></>} />,
				<Route path="profile" show={() => <><Profile /><Nav active="profile" /></>} />,
				<Route path="user/:id" show={(id) => <><Profile id={id} /><Nav active="" /></>} />,
				<Route path="settings" show={() => <><Settings /><Nav active="settings" /></>} />,
				<Route path="home" show={() => <><Timeline type="home" /><Nav active="home" /></>} />,
                <Route path="local" show={() => <><Timeline type="local" /><Nav active="home" /></>} />,
                <Route path="federated" show={() => <><Timeline type="federated" /><Nav active="home" /></>} />,
                <Route path="hashtag/:tag" show={() => <><Timeline type="hashtag" /><Nav active="home" /></>} />,
			]}
		/>
	);

	cx.mount = () => {
		router.route();
	};

	return (
		<app>
			{routerInstance}
		</app>
	);
};


try {
    document.getElementById("app")!.appendChild(<App />);
} catch (e) {
    console.error(e);
    document.body.innerHTML += `
        <pre style="color: black; position: fixed; top: 0; left: 0; overflow: auto; z-index: 9999; margin: 0;">
<span style="background-color: white;">
Errors were encountered while loading the app:
<br><br>
${e instanceof Error ? e.stack : String(e)}
</span>
        </pre>
    `
}